module.exports = __webpack_public_path__ + "img/lte.1c8669f4.png";